import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CapabilitiesFieldset, PerformanceFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';

interface CapabilitiesTabProps {
    context: CollaboratorFormContext;
}

const CapabilitiesTab: React.FC<CapabilitiesTabProps> = ({ context }) => {
    const {
        control,
        setValue,
        watch,
        trigger,
        formState: { errors, isSubmitting }
    } = useFormContext<CollaboratorFormData>();

    return (
        <div className="space-y-6">
            <PerformanceFieldset
                context={context}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
                layout="full"
            />

            <CapabilitiesFieldset
                context={context}
                control={control}
                setValue={setValue}
                watch={watch}
                trigger={trigger}
                errors={errors}
                isSubmitting={isSubmitting}
                layout="full"
            />
        </div>
    );
};

export default CapabilitiesTab;
